import { NetworkProvider } from '@lambda/apis/src/dynamoDb/types';

const CARRIERS = Object.values(NetworkProvider);
const UNLOCKED_TERMS = ['Unlocked', 'Ohne Vertrag', 'Débloqué', 'Libre'];

/** Lowercased and stripped of accents, so "Débloqué" compares as "debloque". */
const normalise = (value: string) =>
  value
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

/** Whether a carrier value means "works with every carrier", in any market. */
export const isUnlocked = (value: string | undefined): boolean =>
  value !== undefined &&
  UNLOCKED_TERMS.some((term) => normalise(term) === normalise(value));

export const splitProductTitle = (title: string) => {
  const [primaryTitle, ...secondaryTitle] = title.split(' - ');
  const carrier = secondaryTitle?.find(
    (part) => isUnlocked(part) || CARRIERS.some((c) => part?.trim() === c),
  );

  return {
    primaryTitle: carrier ? `${primaryTitle} - ${carrier}` : primaryTitle,
    secondaryTitle:
      secondaryTitle.length > 0
        ? secondaryTitle.filter((part) => part?.trim() !== carrier?.trim()).join(' - ')
        : '',
    showUnlocked: isUnlocked(carrier),
  };
};

export const getSavingsAmount = (
  compareAtPrice?: number | null,
  finalPrice?: number | null,
): number | null => {
  if (!compareAtPrice || !finalPrice || compareAtPrice <= finalPrice) {
    return null;
  }

  return compareAtPrice - finalPrice;
};
